export default function Headline(props: { name: string, desc: string, white?: boolean }) {
    return (
        <div className={"headline"}>
            <h1>{props.name}</h1>
            <h2 className={props.white ? "white" : ""} >{props.desc}</h2>
        </div>
    )
}